import { NgModule } from '@angular/core';
import { RouterModule } from '@angular/router';
// tslint:disable-next-line:max-line-length
import { SiteClassificationInputModule } from '@features/admin/@shared/components/site-classification-input/site-classification-input.module';
// tslint:disable-next-line:max-line-length
import { SoilQualityInputModule } from '@features/admin/@shared/components/soil-quality-input/soil-quality-input.module';
import { SiteFileUploadModule } from '@features/admin/@shared/components/source-site-file-upload/site-file-upload.module';
import { FillSiteResolver } from '@features/admin/@shared/resolvers/fill-site.resolver';
import { SourceSiteResolver } from '@features/admin/@shared/resolvers/source-site.resolver';
import { UserResolver } from '@features/admin/@shared/resolvers/user-resolver';
import { SiteCommonModule } from '@widgets/site-common/site-common.module';
import { ReadonlyCompanyProfileComponent } from './components/readonly-company-profile/readonly-company-profile.component';
import { SiteIndexComponent } from './components/site-index/site-index.component';
import { UserIndexComponent } from './components/user-index/user-index.component';
import { SitesCreatedComponent } from './modals/sites-created/sites-created.component';
import { ClientResolver } from './resolvers/client-resolver.service';

@NgModule({
  declarations: [SitesCreatedComponent, SiteIndexComponent, UserIndexComponent, ReadonlyCompanyProfileComponent],
  imports: [SiteCommonModule, RouterModule],
  exports: [
    SitesCreatedComponent,
    SiteIndexComponent,
    UserIndexComponent,
    ReadonlyCompanyProfileComponent,
    SiteFileUploadModule,
    SoilQualityInputModule,
    SiteClassificationInputModule
  ],
  providers: [SourceSiteResolver, FillSiteResolver, UserResolver, ClientResolver]
})
export class AdminSharedModule {}
